import { render, staticRenderFns } from "./JdsEcho.vue?vue&type=template&id=4fe94b12&scoped=true&"
import script from "./JdsEcho.vue?vue&type=script&lang=ts&"
export * from "./JdsEcho.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fe94b12",
  null
  
)

export default component.exports